"use client";

interface WhyVisit {
  Title: string;
  Description: string;
}

interface WhyVisitSectionProps {
  whyVisit: WhyVisit[];
}

export default function WhyVisitSection({ whyVisit }: WhyVisitSectionProps) {
  if (!whyVisit || whyVisit.length === 0) return null;

  return (
    <section className="py-24 bg-[#F9F7F4]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl mb-8 text-[#1A1A1A]">
            Why Visit This Place
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {whyVisit.map((visit, index) => (
              <div
                key={index}
                className="flex items-start gap-3 bg-white rounded-xl px-6 py-4"
              >
                <div className="w-2 h-2 bg-[#B42025] rounded-full mt-2 flex-shrink-0" />
                <div>
                  <p className="text-red-700 text-xl mb-2">{visit.Title}</p>
                  <p className="text-gray-700">{visit.Description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
